import CargaLiquidaRepository from '@/repositories/CargaLiquida';
import TributosRepository from '@/repositories/Tributos';

// state
const state = () => ({
  cargaTributariaEfetivaSelecionada: [],
  paginaTributo: [],
  cargaLiquida: [],
  dadosCargaLiquida: [],
  loadingFetch: [],

  // novo processo - modelo: Antecipacao
  tributos: [],
  tributosComoDeveriaSer: [],
  eventosTributo: [],
  filaRequests: [],
});

// getters
const getters = {
  getCargaTributariaEfetivaSelecionada: (state) => {
    return state.cargaTributariaEfetivaSelecionada;
  },
  getPaginaTributo: (state) => {
    return state.paginaTributo
  },
  getCargaLiquida: (state) => {
    return state.cargaLiquida
  },
  getDadosCargaLiquida: (state) => {
    return state.dadosCargaLiquida
  },
  getTributos: (state) => {
    return state.tributos
  },
  getTributosComoDeveriaSer: (state) => {
    return state.tributosComoDeveriaSer
  },
  getEventosTributo: (state) => {
    return state.eventosTributo
  },
  getFilaRequests: (state) => {
    return state.filaRequests
  },
};

// mutations
const mutations = {
  SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA (state, value) {
    state.cargaTributariaEfetivaSelecionada = value
  },
  SET_PAGINA_TRIBUTO (state, paginaTributo) {
    state.paginaTributo = paginaTributo
  },
  SET_CARGA_LIQUIDA (state, cargaLiquida) {
    state.cargaLiquida = cargaLiquida
  },
  SET_DADOS_CARGA_LIQUIDA (state, dadosCargaLiquida) {
    state.dadosCargaLiquida = dadosCargaLiquida
  },
  SET_LOADING_FETCH (state, loadingFetch) {
    state.loadingFetch = loadingFetch
  },
  SET_TRIBUTOS (state, tributos) {
    state.tributos = tributos
  },
  SET_TRIBUTOS_COMO_DEVERIA_SER (state, tributosComoDeveriaSer) {
    state.tributosComoDeveriaSer = tributosComoDeveriaSer
  },
  SET_EVENTOS_TRIBUTO (state, eventosTributo) {
    state.eventosTributo = eventosTributo
  },
  SET_FILA_REQUESTS (state, filaRequests) {
    state.filaRequests = filaRequests
  },
}

 // actions
 const actions = {
  /**
   * Deve ser chamado quando clicar no botão Resultado
   * @param {String} cenario
   */
  resetCargasCenario ({ commit, state }, { cenario, tributo }) {
    const cargas = state.cargaTributariaEfetivaSelecionada.filter(carga => {
      return !(carga.cenario == cenario && carga.tributo == tributo)
    })

    commit('SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA', cargas)
  },
  async setCargaTributariaEfetiva ({ commit, state }, {cenario, tributo, valor}) {
    let found = false
    var atualiza = await state.cargaTributariaEfetivaSelecionada.map(carga => {
      if (carga.cenario == cenario && carga.tributo == tributo) {
        carga.valor = valor
        found = true
      }
      return carga
    })

    if (!found) {
      atualiza.push({ cenario, tributo, valor })
    }

    let total = 0
    let count = 0
    total = await atualiza.reduce(function(acumulador, carga) {
      if (carga.cenario == cenario) {
        if (Number(carga.valor)) {
          count++
          return acumulador + Number(carga.valor)
        }
      }
      return acumulador
    }, 0)

    commit('SET_CARGA_TRIBUTARIA_EFETIVA_SELECIONADA', atualiza)

    if (count == 1) return null

    return total
  },
  setPaginaTributo ({ commit, state }, { id, classe, sub, pagina }) {
    let paginaTributo = state.paginaTributo

    if (!id || !classe || !sub) return

    if (!pagina) pagina = 1

    if (!paginaTributo) paginaTributo = []
    if (!paginaTributo[id]) paginaTributo[id] = []
    if (!paginaTributo[id][classe]) paginaTributo[id][classe] = []
    if (!paginaTributo[id][classe][sub]) paginaTributo[id][classe][sub] = 1

    paginaTributo[id][classe][sub] = pagina

    commit('SET_PAGINA_TRIBUTO', paginaTributo)
  },
  setCargaLiquida ({ commit, state }, { id, index, value }) {
    let cargaLiquida = state.cargaLiquida

    if (!cargaLiquida[id]) {
      cargaLiquida[id] = []
    }

    cargaLiquida[id][index] = value

    commit('SET_CARGA_LIQUIDA', cargaLiquida)
  },
  async novoFetchDadosCargaLiquida ({ commit, state }, { form }) {
    return await CargaLiquidaRepository.fetchCargaLiquida(form)
  },
  async fetchDadosCargaLiquida ({ commit, state }, { id, form }) {
    let cargaLiquida = state.dadosCargaLiquida
    let loading = state.loadingFetch

    if (!cargaLiquida[id]) {
      cargaLiquida[id] = []
    }

    if (!loading[id]) {
      loading[id] = false
    }

    if (loading[id]) { return }

    loading[id] = true
    commit('SET_LOADING_FETCH', loading)

    cargaLiquida[id] = await CargaLiquidaRepository.fetchCargaLiquida(form)

    loading[id] = false
    commit('SET_LOADING_FETCH', loading)

    commit('SET_DADOS_CARGA_LIQUIDA', cargaLiquida)
  },

  async fetchTributos ({ commit, state }, { id, aba, classe, index, form }) {
    let fila = state.filaRequests
    let found = await fila.filter(f => f.id == id && f.aba == aba && f.classe == classe && f.index == index && f.status != 'finished')
    if (!found.length) {
      fila.push({ id, aba, classe, index, form, status: 'start' })
      commit('SET_FILA_REQUESTS', fila)
    } 
    // else {
    //   if (found.status != 'finished') {
    //     return false
    //   }
    // }

    fila = await fila.map(f => {
      if (!(f.id == id && f.aba == aba && f.classe == classe && f.index == index && f.status != 'finished')) { return f }
      f.status = f.status == 'start' ? 'waiting' : f.status
      return f
    })
    commit('SET_FILA_REQUESTS', fila)

    let response = await TributosRepository.fetch({ aba, classe, index, form })

    fila = await fila.map(f => {
      if (!(f.id == id && f.aba == aba && f.classe == classe && f.index == index)) { return f }
      f.status = f.status == 'waiting' ? 'finished' : f.status
      return f
    })

    commit('SET_FILA_REQUESTS', fila)

    return response
  },

  setTributosOld ({ commit, state }, { id, aba, classe, dados }) {
    // let tributos = state.tributos

    // if (typeof id === 'undefined' || id == null) return
    // if (!aba || aba == null) { return }
    // if (!classe || classe == null) return 
    // if (!dados) return

    // if (!tributos[id]) tributos[id] = []
    // if (!tributos[id][aba]) tributos[id][aba] = []
    // if (!tributos[id][aba][classe]) tributos[id][aba][classe] = []

    // tributos[id][aba][classe] = dados

    // tributos = tributos.filter((t, index) => {
    //   return t
    // })

    // commit('SET_TRIBUTOS', tributos)
  },
  setTributos ({ commit, state }, { id, aba, classe, dados }) {
    let tributos = state.tributos

    if (!id || !aba || !classe || !dados) {
      return
    }

    let tributo = tributos.find(t => t.id == id && t.aba == aba && t.classe == classe)

    if (!tributo) {
      tributos.push({ id, aba, classe, dados })
    } else {
      tributos = tributos.map(t => {
        t.dados = t == tributo ? dados : t.dados
        return t
      })
    }

    commit('SET_TRIBUTOS', tributos)
  },
  resetTributos ({ commit }) {
    commit('SET_TRIBUTOS', [])
  },
  removeTributos ({ commit, state }, id) {
    let tributos = state.tributos.filter(t => t.id != id)

    commit('SET_TRIBUTOS', tributos)
  },
  setEventosTributo ({ commit, state }, event) {
    let eventosTributo = state.eventosTributo

    eventosTributo.push(event)

    commit('SET_EVENTOS_TRIBUTO', eventosTributo)
  },
  resetEventosTributo ({ commit, state }) {
    let eventosTributo = state.eventosTributo

    eventosTributo = []

    commit('SET_EVENTOS_TRIBUTO', eventosTributo)

  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
